import { useDispatch } from "react-redux"
import useFetch from "../../hooks/useFetch"
import UserService from "../UserService"
import { unsetAuth } from "../../store/reducers/user-reducer"

export default function useLogout() {
    const dispatch = useDispatch()
    const exit = async () => {
        localStorage.removeItem('accessToken')
        await UserService.Logout()
        dispatch(unsetAuth())
    }

    const [logout, isLoading, error, errors] = useFetch(exit)
    return {logout, isLoading, error, errors}
}